import { Pumps } from "../../pages/Pumps";

export function MobilePumps() {
  return <Pumps />;
}
